import {Component, Inject} from '@angular/core';
import {InsightPopupService} from '../insight-popup.service';
import {from, Observable} from 'rxjs';
import {LocalePipe} from '../../../../services/locale/locale.pipe';
import {LocaleService} from '../../../../services/locale/locale.service';
import {TranslateService} from '@ngx-translate/core';
import {
    LEARNING_PROGRESS_INSIGHT,
    LearningProgressInsightService
} from '../../../../services/LearningProgressInsightService';
import {
    LearningPackageInsightsDetailsResponseDto
} from '../../../../services/rest/api-types/LearningPackageInsightsDetailsResponseDto';
import {filter, map, switchMap} from 'rxjs/operators';
import {InsightTabs} from '../InsightTabs';
import {
    ImpersonationService
} from '../../../../../../../micromate-learn-web/src/app/core/authentication/impersonation.service';

@Component({
    selector: 'mm-detail-insight-popup',
    templateUrl: './detail-insight-popup.component.html',
    styleUrl: './detail-insight-popup.component.scss',
    standalone: false
})
export class DetailInsightPopupComponent {
    constructor(public insightPopupService: InsightPopupService,
                public impersonationService: ImpersonationService,
                private localService: LocaleService,
                private translateService: TranslateService,
                @Inject(LEARNING_PROGRESS_INSIGHT) private learningProgressInsightService: LearningProgressInsightService) {
    }

    public learningPackageData$: Observable<LearningPackageInsightsDetailsResponseDto> = this.insightPopupService.selectedLearningPackageId$.pipe(
        filter((learningPackageId): learningPackageId is string => learningPackageId !== undefined),
        switchMap((learningPackageId: string) => this.learningProgressInsightService.getLearningProgressInsightDetails(learningPackageId))
    );

    public languages$ = this.learningPackageData$.pipe(
        switchMap((learningPackageData: LearningPackageInsightsDetailsResponseDto) => {
            const localePipe = new LocalePipe(this.localService, this.translateService);
            return from(Promise.all(learningPackageData.languages.map(async lang => localePipe.transform(lang, 'long'))));
        }),
        map((names: string[]) => names.join(', ')));

    public async learnPackage(learningPackageId: string): Promise<void> {
        await this.learningProgressInsightService.learnLearningPackage(learningPackageId)
    }

    protected readonly InsightTabs = InsightTabs;
}
